export const getBlocks = (resourceid: string, limit: number, offset: number) => {
  const query = [
    "SELECT ?block ?blockItem ?startAuthorBirthDate ?bcm ?bct",
    "WHERE {",
      "{",
        "<" + resourceid + "> <http://scta.info/property/hasStructureItem> ?item .",
        "?item <http://scta.info/property/totalOrderNumber> ?itemTotalOrderNumber .",
        "?item <http://scta.info/property/hasStructureBlock> ?block .",
        // bcm and bcm are here to get transcription ids so that text can be retrieved from onclick event
        "?block <http://scta.info/property/hasCanonicalManifestation> ?bcm .",
        "?bcm <http://scta.info/property/hasCanonicalTranscription> ?bct .",
      "}",
      "UNION",
      "{",
        "<" + resourceid + "> <http://scta.info/property/hasStructureBlock> ?block .",
        // bcm and bcm are here to get transcription ids so that text can be retrieved from onclick event
        "?block <http://scta.info/property/hasCanonicalManifestation> ?bcm .",
        "?bcm <http://scta.info/property/hasCanonicalTranscription> ?bct .",
      "}",
      "?block <http://scta.info/property/totalOrderNumber> ?totalOrderNumber .",
      "?block <http://scta.info/property/isPartOfStructureItem> ?blockItem . ",
      "OPTIONAL{",
        "?blockItem <http://scta.info/property/isPartOfTopLevelExpression> ?topLevel . ",
        "?topLevel <http://www.loc.gov/loc.terms/relators/AUT> ?author . ",
        "?author <http://purl.org/dc/elements/1.1/title> ?authorTitle . ",
        "?author <http://scta.info/property/dateOfBirth> ?startAuthorBirthDate .",
        "}",
      "}",
      "ORDER BY ?itemTotalOrderNumber ?totalOrderNumber",
      "LIMIT " + limit, 
      "OFFSET " + offset
    ].join(" ")
  return query
}

export const getNgramMatches = (values: any, intersectionTotal: number = 4, expression?: string, expressionType?: string, workGroup?: string) => {
  const query = [
    "SELECT (COUNT(*) as ?count) ?start ?target ?targetItem ?authorBirthDate ?ccm ?cct ",
      "WHERE {",
        "VALUES ?start {" + values + "}",  
        "?ngram <http://scta.info/property/isFoundIn> ?start .",
        "?ngram <http://scta.info/property/isFoundIn> ?target .",
        "FILTER(?start != ?target) .",
        // "FILTER NOT EXISTS {",
        //   "VALUES ?list_of_ngrams {" + stop_grams + "}",
        //   "FILTER (?ngram IN (?list_of_ngrams))",
        // "}",
        "?target <http://scta.info/property/totalOrderNumber> ?targetTotalOrderNumber . ",
        "?target <http://scta.info/property/isPartOfStructureItem> ?targetItem . ",
        // ccm and cct are here to get transcription ids so that text can be retrieved from onclick event
        "?target <http://scta.info/property/hasCanonicalManifestation> ?ccm .",
        "?ccm <http://scta.info/property/hasCanonicalTranscription> ?cct .",
        "?targetItem <http://scta.info/property/isPartOfTopLevelExpression> ?topLevel . ",
        "?targetItem <http://scta.info/property/totalOrderNumber> ?targetItemTotalOrderNumber .",
        "?start <http://scta.info/property/isPartOfStructureItem> ?startItem . ",
        "?startItem <http://scta.info/property/isPartOfTopLevelExpression> ?startTopLevel . ",
        "FILTER(?startTopLevel != ?topLevel) .",
        expression && "?target <http://scta.info/property/isMemberOf> <" + expression + "> . ",
        expressionType && "?target <http://scta.info/property/isMemberOf> ?member . ?member <http://scta.info/property/expressionType> <" + expressionType + "> .",
        workGroup && "<" + workGroup + "> <http://scta.info/property/hasExpression> ?topLevel  .",
        "OPTIONAL{",
        "?topLevel <http://www.loc.gov/loc.terms/relators/AUT> ?author . ",
        "?author <http://purl.org/dc/elements/1.1/title> ?authorTitle . ",
        "?author <http://scta.info/property/dateOfBirth> ?authorBirthDate .",
        "}",
        "}",
        "GROUP BY ?start ?target ?targetTotalOrderNumber ?targetItem ?topLevel ?targetItemTotalOrderNumber ?author ?authorTitle ?authorBirthDate ?ccm ?cct",
        "HAVING (?count >= " + intersectionTotal + ")",
        "ORDER BY ?authorBirthDate ?topLevel ?targetItemTotalOrderNumber ?targetTotalOrderNumber",
        //"ORDER BY ?authorTitle ?topLevel ?targetItemTotalOrderNumber ?targetTotalOrderNumber"
        // "LIMIT 1000",
        // "OFFSET " + yoffset
      ].join(' ')
  return query
}
